"use client";

import { useEffect, useContext, useState, useRef, useMemo } from "react";
import Cookies from "js-cookie";
import FieldsContext from "../../../context/FieldsContext";
import { useNavigate } from "react-router-dom";
import { ColorRing } from "react-loader-spinner";
import "./index.css";

const AppLandingPage = (props) => {
  const { setFields } = useContext(FieldsContext);
  const [current_app] = useState(props.app);
  const [landingPage, setLandingPage] = useState(null);
  const navigate = useNavigate();
  const aboutRef = useRef();
  const validRef = useRef();
  const researchRef = useRef();
  const TakeMetoAppRef = useRef();
  const [termsofuse, setTermsOfUse] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [previousIconId, setPreviousIconId] = useState(null);
  const [clickTermsOfUse, setClickTermsOfUse] = useState(false);
  const [hover, setHover] = useState(false);
  const [takeHover, setTakeMeHover] = useState(false);
  const [takeMeButton, setTakeMeButton] = useState(false);

  const [tokenExpiry, setExpiry] = useState(false);
  const token = Cookies.get("sas_token");

  useEffect(() => {
    const fetchData = async () => {
      const url = props.LANDING_URL;
      const jwt_token = Cookies.get("jwt_token");
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${jwt_token}`);

      const options = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      try {
        const response = await fetch(url, options);
        const responseObj = await response.json();
        if (responseObj.status === "success") {
          setFields(responseObj.data);
          setLandingPage(responseObj.data.landing_page);
          localStorage.setItem("fields", JSON.stringify(responseObj.data));
        } else {
          alert("Failed to fetch the data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [setFields, navigate, props.LANDING_URL, props.app, current_app]);

  const logOut = () => {
    Cookies.remove("jwt_token");
    Cookies.remove("sas_token");
    localStorage.clear();
    navigate("/login");
  };

  const triggerTermsBox = () => {
    setTermsOfUse(!termsofuse);
  };

  const OnChangeTermsOfUse = () => {
    setClickTermsOfUse(!clickTermsOfUse);
    setTakeMeButton(false);
  };

  const returnToHome = () => {
    navigate("/");
  };

  const handleClickScrollTo = (ref, id) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
    if (previousIconId && previousIconId !== id) {
      const previousIcon = document.getElementById(previousIconId);
      if (previousIcon) {
        previousIcon.style.backgroundColor = ""; // Reset to default
      }
    }
    const iconElement = document.getElementById(id);
    if (iconElement) {
      iconElement.style.backgroundColor = props.surface_highlight_color;
    }
    setPreviousIconId(id);
  };

  const takeMeToAction = () => {
    clickTermsOfUse &&
      navigate(
        `/${current_app === "aicopd" ? "copd" : current_app}/patient-details`
      );
    setTakeMeButton(true);
  };

  const getImageBlobUrl = useMemo(() => {
    const imageMap = new Map(props.images.map((img) => [img.id, img.blobUrl]));
    return (id) => imageMap.get(id) || "";
  }, [props.images]);

  function isTokenExpired(url) {
    try {
      const urlParams = new URL(url).searchParams;
      const expiryTime = urlParams.get("se");

      if (expiryTime) {
        const expiryDate = new Date(expiryTime);
        const now = new Date(); // Current time

        return now > expiryDate; // Return true if current time is past expiry
      }

      console.error("The 'se' parameter is missing in the URL.");
      setExpiry(true);
      return true; // Assume expired if 'se' is missing
    } catch (error) {
      console.error("Error parsing URL:", error);
      setExpiry(true);
      return true; // Assume expired in case of errors
    }
  }

  const triggerPrivacyBox = () => {
    setPrivacyPolicy(!privacyPolicy);
  };
  const isMobile = window.innerWidth <= 768;

  return landingPage ? (
    <div className="app-info-landing-page-container">
      <nav
        className="heading-bar-container"
        style={{ backgroundColor: props.surface_color }}
      >
        <div className="apollo-image-logo-container">
          <img
            src={
              isTokenExpired(
                `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png?${
                  token || "/placeholder.svg"
                }`
              ) || tokenExpiry
                ? getImageBlobUrl(`${props.app}-image-1`)
                : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png?${token}`
            }
            alt="apollo-logo"
            className="apollo-image"
          />
        </div>
        <ul className="list-of-redirect-elements">
          <div className="landingpage-action-icons">
            <div
              id="about-icon"
              className="app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(aboutRef, "about-icon")}
            >
              <img src="/group.png" alt="about-icon" className="icon-landing" />
            </div>
            <li
              className="nav-link-buttons"
              onClick={() => handleClickScrollTo(aboutRef, "about-icon")}
            >
              About
            </li>
          </div>

          <div className="landingpage-action-icons">
            <div
              id="validation-icon"
              className="app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(validRef, "validation-icon")}
            >
              <img
                src="/validation.png"
                alt="validation-icon"
                className="icon-landing"
              />
            </div>

            <li
              className="nav-link-buttons"
              onClick={() => handleClickScrollTo(validRef, "validation-icon")}
            >
              Validation
            </li>
          </div>
          <div className="landingpage-action-icons">
            <div
              id="research-icon"
              className="app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(researchRef, "research-icon")}
            >
              <img
                src="/research-svgrepo-com.svg"
                alt="research-icon"
                className="icon-landing"
              />
            </div>

            <li
              className="nav-link-buttons"
              onClick={() => handleClickScrollTo(researchRef, "research-icon")}
            >
              The Research
            </li>
          </div>

          <div className="landingpage-action-icons">
            <div
              id="app-icon"
              className="app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(TakeMetoAppRef, "app-icon")}
            >
              <img
                src="/icons8-app.svg"
                alt="app-icon"
                className="icon-landing"
              />
            </div>

            <li
              className="nav-link-buttons"
              onClick={() => handleClickScrollTo(TakeMetoAppRef, "app-icon")}
            >
              App
            </li>
          </div>

          <div className="landingpage-action-icons">
            <div id="app-icon" className="app-landing-page-icon-container">
              {props.app === "aicvd" && (
                <a
                  className="app-landing-page-icon-container"
                  href="/FAQ-AICVD-2026.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/faq.png" alt="app-icon" className="icon-landing" />
                </a>
              )}
              {props.app === "liver" && (
                <a
                  className="app-landing-page-icon-container"
                  href="/FAQ-AILF-2026.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/faq.png" alt="app-icon" className="icon-landing" />
                </a>
              )}
              {props.app === "prediabetes" && (
                <a
                  className="app-landing-page-icon-container"
                  href="/FAQ-PrediabetesAI-2026.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="faq.png" alt="app-icon" className="icon-landing" />
                </a>
              )}
              {props.app === "hypertension" && (
                <a
                  className="app-landing-page-icon-container"
                  href="/FAQ-AI-Hypertension-2026.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="faq.png" alt="app-icon" className="icon-landing" />
                </a>
              )}
              {props.app === "aicopd" && (
                <a
                  className="app-landing-page-icon-container"
                  href="/FAQ-AICOPD-2026.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="faq.png" alt="app-icon" className="icon-landing" />
                </a>
              )}
            </div>
            <li className="nav-link-buttons">FAQ</li>
          </div>
        </ul>
        <div className="logout-button-container-block">
          <div className="landingpage-action-icons">
            <div
              className="app-landing-page-icon-container"
              onClick={returnToHome}
            >
              <img
                src="icons8-home.svg"
                alt="home-icon"
                className="icon-landing"
              />
            </div>

            <button className="logout-button">Home</button>
          </div>
          <div className="landingpage-action-icons">
            <div className="app-landing-page-icon-container" onClick={logOut}>
              <img
                src="logout-svgrepo-com.svg"
                alt="logout-icon"
                className="icon-landing"
              />
            </div>

            <button className="logout-button">Log Out</button>
          </div>
        </div>
      </nav>
      <main className="main-container">
        <div className="main-inner-container">
          <div className="section-block-container margin-top-10">
            <div
              className="home-page-content-container"
              style={{ backgroundColor: props.surface_color }}
            >
              <h1
                className="heading-apollo-text"
                style={{ color: props.color }}
              >
              
                {current_app === "prediabetes"
                  ? `${`Prediabetes AI`}`
                  : current_app === "liver"
                  ? `${`Ailf`.toUpperCase()}`
                  : current_app === "hypertension"
                  ? `${`AI Hypertension`.toUpperCase()}`
                  : current_app.toUpperCase()}
              </h1>
              <div
                className="about-us-container"
                style={{
                  backgroundColor: hover
                    ? props.button_hover_color
                    : props.color,
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => handleClickScrollTo(aboutRef, "about-icon")}
              >
                <button type="button" className="about-us-button">
                  About us
                </button>
              </div>
            </div>
            <div className="home-page-image-container">
              {props.app === "aicopd" ? (
                <img
                  src={
                    isTokenExpired(
                      `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${
                        props.app || "/placeholder.svg"
                      }-landing-image.png?${token}`
                    ) || tokenExpiry
                      ? getImageBlobUrl(`${props.app}-image-2`)
                      : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${props.app}-landing-image.png?${token}`
                  }
                  className="copd-home-page-image"
                  alt="home-page"
                />
              ) : props.app !== "liver" ? (
                <img
                  src={
                    isTokenExpired(
                      `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${
                        props.app || "/placeholder.svg"
                      }-landing-image.jpg?${token}`
                    ) || tokenExpiry
                      ? getImageBlobUrl(`${props.app}-image-2`)
                      : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${props.app}-landing-image.jpg?${token}`
                  }
                  className="copd-home-page-image"
                  alt="home-page"
                />
              ) : (
                <img
                  src={
                    isTokenExpired(
                      `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${
                        props.app || "/placeholder.svg"
                      }-landing-image.jpeg?${token}`
                    ) || tokenExpiry
                      ? getImageBlobUrl(`${props.app}-image-2`)
                      : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${props.app}-landing-image.jpeg?${token}`
                  }
                  className="copd-home-page-image"
                  alt="home-page"
                />
              )}
            </div>
          </div>
          <div className="main-section-inner-block">
            <div
              className="each-individual-section section-border"
              ref={aboutRef}
            >
              <h2 className="each-section-heading">{landingPage[1].heading}</h2>
              <div className="section-block-container">
                <div className="landing-content-container">
                  <ul
                    className="landing-list list-style-type"
                    style={{ backgroundColor: props.surface_color }}
                  >
                    {landingPage[1].points.map((point, index) => {
                      if (typeof point === "object" && point.mainPoint) {
                        return (
                          <li key={index}>
                            <>{point.mainPoint}</>
                            <ul className="sub-points-list-container list-style-type">
                              {point.subPoints.map((subPoint, subIndex) => (
                                <li key={`${index}-${subIndex}`}>{subPoint}</li>
                              ))}
                            </ul>
                          </li>
                        );
                      } else {
                        return (
                          <li key={index} className="">
                            {point}
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
                <div className="image-container-block mobile-view-image-container">
                  <>
                    <div className="why-image-container image-1-block">
                      <img
                        src={
                          isTokenExpired(
                            `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${
                              props.app || "/placeholder.svg"
                            }-app-page-1.jpg?${token}`
                          ) || tokenExpiry
                            ? getImageBlobUrl(`${props.app}-image-3`)
                            : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${props.app}-app-page-1.jpg?${token}`
                        }
                        alt="Healthcare-1"
                        className="why-image"
                      />
                    </div>
                    <div className="why-image-container image-12block">
                      <img
                        src={
                          isTokenExpired(
                            `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${
                              props.app || "/placeholder.svg"
                            }-app-page-2.jpg?${token}`
                          ) || tokenExpiry
                            ? getImageBlobUrl(`${props.app}-image-4`)
                            : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${props.app}-app-page-2.jpg?${token}`
                        }
                        alt="Healthcare-1"
                        className="why-image"
                      />
                    </div>
                  </>
                </div>
              </div>
            </div>
            <div
              className="each-individual-section section-border"
              ref={validRef}
            >
              <h2 className="each-section-heading">{landingPage[2].heading}</h2>
              <div className="section-block-container align-flex-start">
                <div className="landing-content-container">
                  <ul
                    className="landing-list"
                    style={{ backgroundColor: props.surface_color }}
                  >
                    {landingPage[2].points.map((point, index) => {
                      if (typeof point === "object") {
                        return (
                          <li key={index} className="">
                            <strong>{point.heading}</strong>
                            <p className="landing-list-point">{point.points}</p>
                          </li>
                        );
                      } else {
                        return (
                          <li key={index} className="">
                            {point}
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
                <div className="imterpretation-image-container-block">
                  <img
                    src={
                      isTokenExpired(
                        `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${
                          props.app || "/placeholder.svg"
                        }-intepretation-img.jpg?${token}`
                      ) || tokenExpiry
                        ? getImageBlobUrl(`${props.app}-image-5`)
                        : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/${props.app}-intepretation-img.jpg?${token}`
                    }
                    alt="intepretation"
                    className="intepretation-image"
                    style={{
                      height: isMobile
                        ? "400px"
                        : props.app === "prediabetes"
                        ? "740px"
                        : props.app === "liver"
                        ? "440px"
                        : "505px",
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="each-individual-section section-border"
              ref={researchRef}
            >
              <h2 className="each-section-heading">{landingPage[3].heading}</h2>
              <div className="section-block-container">
                <ul
                  className="landing-list"
                  style={{ backgroundColor: props.surface_color }}
                >
                  {landingPage[3].points.map((section, sectionIndex) => {
                    if (typeof section === "object") {
                      return (
                        <ul key={sectionIndex} className="">
                          <strong className="inner-sub-heading">
                            {section.heading}
                          </strong>
                          {Array.isArray(section.points) ? (
                            <ul className="section-3-list">
                              {section.points.map((subPoint, subIndex) => (
                                <li key={subIndex}>{subPoint}</li>
                              ))}
                            </ul>
                          ) : (
                            <p className="section3-point">{section.points}</p>
                          )}
                        </ul>
                      );
                    } else return <li key={section}>{section}</li>;
                  })}
                  {landingPage[3].link && (
                    <div className="link-text">
                      <h3>
                        Full text paper available here
                        <img
                          src="point-down.png"
                          alt="down"
                          className="link-point-img"
                        />
                        :
                      </h3>
                      <a
                        href={landingPage[3].link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {landingPage[3].linkText}
                      </a>
                    </div>
                  )}
                </ul>
              </div>
            </div>
            <div className="each-individual-section section-border">
              <h2 className="each-section-heading">
                {landingPage[4].heading}
              </h2>
              <div className="section-block-container">
                <div className="landing-content-container">
                  <ul
                    className="landing-list list-style-type"
                    style={{ backgroundColor: props.surface_color }}
                  >
                    {landingPage[4].points.map((point, index) => {
                      
                      if (typeof point === "string") {
                        return <li key={index}>{point}</li>;
                      }
                      if (point.type === "regulatory") {
                        return (
                          <li key={index} style={{ listStyle: "none" }}>
                            <div className="regulatory-box">
                              <strong>{point.title}</strong>
                              {point.values.map((val, i) => (
                                <p key={i}>{val}</p>
                              ))}
                            </div>
                          </li>
                        );
                      }

                      return null;
                    })}

                    <p className="certificate-note-point">
                      {landingPage[4].content}
                    </p>
                  </ul>
                </div>

                <div className="cerficate-image-container-block">
                  <div className="cerficate-intepretation-container">
                    <img
                      src={
                        isTokenExpired(
                          `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_mdsap_certificate_2026.jpg?${
                            token || "/placeholder.svg"
                          }`
                        ) || tokenExpiry
                          ? getImageBlobUrl(`${props.app}-image-6`)
                          : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_mdsap_certificate_2026.jpg?${token}`
                      }
                      alt="certificate"
                      className="cerficate-image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div ref={TakeMetoAppRef} className="container take-me-to-app">
              <div className="checkbox-with-text">
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    className="checkbox-input"
                    id="loginCheckBox"
                    onChange={OnChangeTermsOfUse}
                  />
                  <span className="custom-checkbox">
                    <img
                      src="checkmark-outline-white.svg"
                      alt="checkmark-outline-white"
                    />
                  </span>
                </div>
                <label htmlFor="loginCheckBox" className="app-checkbox-text">
                  <span
                    style={{
                      color: takeMeButton ? "red" : "black",
                      fontWeight: takeMeButton ? "600" : "500",
                    }}
                  >
                    I Accept the{" "}
                  </span>
                  <button
                    type="button"
                    className="new-user-link-tag"
                    href="#"
                    onClick={triggerTermsBox}
                  >
                    Terms of use
                  </button>
                </label>
              </div>
              <button
                id="TakeToMeApp"
                type="button"
                onClick={takeMeToAction}
                style={{
                  backgroundColor: takeHover
                    ? "rgb(123, 104, 171)"
                    : "rgb(103, 84, 150)",
                }}
                onMouseEnter={() => setTakeMeHover(true)}
                onMouseLeave={() => setTakeMeHover(false)}
              >
                Take me to App
              </button>
            </div>

            {props.app === "aicvd" && termsofuse && (
              <div id="aicvd-termsBox" className="app-popup-main-container">
                <div className="app-popup-container">
                  <h1 className="app-popup-content-heading">Terms of Use</h1>
                  <div className="app-popup-content-container">
                    <p className="app-popup-text">
                      By agreeing to use the AICVD Application, I have been made
                      aware of the hardware and software requirements that I
                      will need to set up from my side for a smooth and
                      uninterrupted flow of the Application Programming
                      Interface (API). I undertake to abide by all applicable
                      laws and regulations for the safe and ethical delivery of
                      medical services through this platform and shall adhere by
                      the protocols and standard of care as required. The
                      information that I shared with Apollo Hospitals’ AICVD
                      API, is true to my knowledge and belief and I will be
                      responsible for any legal liability that may arise from
                      in-appropriation of any personal or professional
                      information shared or entered in the API. I accept that I
                      shall be solely responsible for the medical advice and
                      recommendations prescribed post consultation with patients
                      via the AICVD App. and any liability that may arise
                      therefrom. I have understood the following disclaimers
                      associated with the use of the AICVD API
                    </p>
                    <ul className="app-popup-list-container">
                      <li>
                        This is not a diagnostic tool and it does not guarantee
                        the accuracy of the result and cannot be independently
                        acted upon.
                      </li>
                      <li>
                        This Risk score and Clinical Algorithm is a general
                        guideline for Physicians. Any additional laboratory
                        investigations, Diagnostic Imaging, Treatment or Patient
                        Education related to lifestyle management is under the
                        Physician’s or Cardiologist’s discretion.
                      </li>
                      <li>
                        To ensure the information in the report is up to date,
                        accurate and correct, Doctor shall be consulted for
                        interpretation of the report. He / She shall also ensure
                        that the entries made in the API are correct.
                      </li>
                      <li>
                        Apollo Hospitals and its Staff does not offer any
                        assurance on the information made available or shall be
                        liable for any loss or damage as the said report is
                        based on the AICVD Cardiac Risk Score without any
                        intervention from their side.
                      </li>
                      <li>
                        By usage of AICVD Cardiac Risk Score, it is deemed that
                        the beneficiary of this service has agreed to get the
                        same done at his/her own risk and further agrees with
                        this disclaimer without any limitation or any clauses or
                        sub-clauses.{" "}
                      </li>
                    </ul>
                    <p className="app-popup-text">
                      Confidentiality: Each Party hereby undertakes that it will
                      not disclose the Confidential Information of the other
                      party, except to its affiliates, employees, and/or agents
                      who need to know such Confidential Information for the
                      purpose of performance of obligations hereunder, provided
                      they have agreed in writing to keep such information
                      confidential and to not use such information for any
                      unauthorized purposes. The recipient of Confidential
                      Information may disclose Confidential Information as
                      required under Applicable Laws, after giving to the
                      discloser of such Confidential Information, reasonable
                      notice and the opportunity to seek confidential treatment
                      by way of a protective order or similar remedies or relief
                      prior to disclosure, in each case if permitted by
                      applicable Law. Except as set forth in this Agreement,
                      neither Party will issue any public announcement.
                    </p>
                  </div>
                  <div className="app-popup-close-container">
                    <button
                      className="app-popup-close-button"
                      type="button"
                      onClick={triggerTermsBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {props.app === "liver" && termsofuse && (
              <div id="aicvd-termsBox" className="app-popup-main-container">
                <div className="app-popup-container">
                  <h1 className="app-popup-content-heading">Terms of Use</h1>
                  <div className="app-popup-content-container">
                    <p className="app-popup-text">
                      By agreeing to use the AI Liver Fibrosis Application, I
                      have been made aware of the hardware and software
                      requirements that I will need to set up from my side for a
                      smooth and uninterrupted flow of the Application
                      Programming Interface (API). I undertake to abide by all
                      applicable laws and regulations for the safe and ethical
                      delivery of medical services through this platform and
                      shall adhere by the protocols and standard of care as
                      required. The information that I shared with Apollo
                      Hospitals’ AI-LF API, is true to my knowledge and belief
                      and I will be responsible for any legal liability that may
                      arise from in-appropriation of any personal or
                      professional information shared or entered in the API. I
                      accept that I shall be solely responsible for the medical
                      advice and recommendations prescribed post consultation
                      with patients via the AI-LF App. and any liability that
                      may arise therefrom. I have understood the following
                      disclaimers associated with the use of the AILF API
                    </p>
                    <ul className="app-popup-list-container">
                      <li>
                        This is not a diagnostic tool and it does not guarantee
                        the accuracy of the result and cannot be independently
                        acted upon.
                      </li>
                      <li>
                        This Risk score and Clinical Algorithm is a general
                        guideline for Physicians. Any additional laboratory
                        investigations, Diagnostic Imaging, Treatment or Patient
                        Education related to lifestyle management is under the
                        Physician’s or Gastroenterologist discretion.
                      </li>
                      <li>
                        To ensure the information in the report is up to date,
                        accurate and correct, Doctor shall be consulted for
                        interpretation of the report. He / She shall also ensure
                        that the entries made in the API are correct.
                      </li>
                      <li>
                        Apollo Hospitals and its Staff does not offer any
                        assurance on the information made available or shall be
                        liable for any loss or damage as the said report is
                        based on the AI Liver Fibrosis Risk Score without any
                        intervention from their side.{" "}
                      </li>
                      <li>
                        By usage of AI based Liver Fibrosis Risk Score, it is
                        deemed that the beneficiary of this service has agreed
                        to get the same done at his/her own risk and further
                        agrees with this disclaimer without any limitation or
                        any clauses or sub-clauses.
                      </li>
                    </ul>
                    <p className="app-popup-text">
                      Confidentiality: Each Party hereby undertakes that it will
                      not disclose the Confidential Information of the other
                      party, except to its affiliates, employees, and/or agents
                      who need to know such Confidential Information for the
                      purpose of performance of obligations hereunder, provided
                      they have agreed in writing to keep such information
                      confidential and to not use such information for any
                      unauthorized purposes. The recipient of Confidential
                      Information may disclose Confidential Information as
                      required under Applicable Laws, after giving to the
                      discloser of such Confidential Information, reasonable
                      notice and the opportunity to seek confidential treatment
                      by way of a protective order or similar remedies or relief
                      prior to disclosure, in each case if permitted by
                      applicable Law. Except as set forth in this Agreement,
                      neither Party will issue any public announcement.
                    </p>
                  </div>
                  <div className="app-popup-close-container">
                    <button
                      className="app-popup-close-button"
                      type="button"
                      onClick={triggerTermsBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {props.app === "prediabetes" && termsofuse && (
              <div id="aicvd-termsBox" className="app-popup-main-container">
                <div className="app-popup-container">
                  <h1 className="app-popup-content-heading">Terms of Use</h1>
                  <div className="app-popup-content-container">
                    <p className="app-popup-text">
                      By agreeing to use the Prediabetes AI Application, I have
                      been made aware of the hardware and software requirements
                      that I will need to set up from my side for a smooth and
                      uninterrupted flow of the Application Programming
                      Interface (API). I undertake to abide by all applicable
                      laws and regulations for the safe and ethical delivery of
                      medical services through this platform and shall adhere by
                      the protocols and standard of care as required. The
                      information that I shared with Apollo Hospitals’
                      Prediabetes AI API, is true to my knowledge and belief and
                      I will be responsible for any legal liability that may
                      arise from in-appropriation of any personal or
                      professional information shared or entered in the API. I
                      accept that I shall be solely responsible for the medical
                      advice and recommendations prescribed post consultation
                      with patients via the Prediabetes AI App. and any
                      liability that may arise therefrom. I have understood the
                      following disclaimers associated with the use of the
                      Prediabetes AI API
                    </p>
                    <ul className="app-popup-list-container">
                      <li>
                        This is not a diagnostic tool and it does not guarantee
                        the accuracy of the result and cannot be independently
                        acted upon.
                      </li>
                      <li>
                        This Risk score and Clinical Algorithm is a general
                        guideline for Physicians. Any additional laboratory
                        investigations, Diagnostic Imaging, Treatment or Patient
                        Education related to lifestyle management is under the
                        Physician’s, Endocrinologist or Diabetologist
                        discretion.{" "}
                      </li>
                      <li>
                        To ensure the information in the report is up to date,
                        accurate and correct, Doctor shall be consulted for
                        interpretation of the report. He / She shall also ensure
                        that the entries made in the API are correct.
                      </li>
                      <li>
                        Apollo Hospitals and its Staff does not offer any
                        assurance on the information made available or shall be
                        liable for any loss or damage as the said report is
                        based on the AI based Prediabetes Risk Score without any
                        intervention from their side.
                      </li>
                      <li>
                        By usage of Prediabetes AI Risk Score, it is deemed that
                        the beneficiary of this service has agreed to get the
                        same done at his/her own risk and further agrees with
                        this disclaimer without any limitation or any clauses or
                        sub-clauses.
                      </li>
                    </ul>
                    <p className="app-popup-text">
                      Confidentiality: Each Party hereby undertakes that it will
                      not disclose the Confidential Information of the other
                      party, except to its affiliates, employees, and/or agents
                      who need to know such Confidential Information for the
                      purpose of performance of obligations hereunder, provided
                      they have agreed in writing to keep such information
                      confidential and to not use such information for any
                      unauthorized purposes. The recipient of Confidential
                      Information may disclose Confidential Information as
                      required under Applicable Laws, after giving to the
                      discloser of such Confidential Information, reasonable
                      notice and the opportunity to seek confidential treatment
                      by way of a protective order or similar remedies or relief
                      prior to disclosure, in each case if permitted by
                      applicable Law. Except as set forth in this Agreement,
                      neither Party will issue any public announcement.
                    </p>
                  </div>
                  <div className="app-popup-close-container">
                    <button
                      className="app-popup-close-button"
                      type="button"
                      onClick={triggerTermsBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {props.app === "aicopd" && termsofuse && (
              <div id="aicvd-termsBox" className="app-popup-main-container">
                <div className="app-popup-container">
                  <h1 className="app-popup-content-heading">Terms of Use</h1>
                  <div className="app-popup-content-container">
                    <p className="app-popup-text">
                      By agreeing to use the AICOPD Application, I have been
                      made aware of the hardware and software requirements that
                      I will need to set up from my side for a smooth and
                      uninterrupted flow of the Application Programming
                      Interface (API). I undertake to abide by all applicable
                      laws and regulations for the safe and ethical delivery of
                      medical services through this platform and shall adhere by
                      the protocols and standard of care as required. The
                      information that I shared with Apollo Hospitals’ AICOPD
                      API, is true to my knowledge and belief and I will be
                      responsible for any legal liability that may arise from
                      in-appropriation of any personal or professional
                      information shared or entered in the API. I accept that I
                      shall be solely responsible for the medical advice and
                      recommendations prescribed post consultation with patients
                      via the AICOPD App. and any liability that may arise
                      therefrom. I have understood the following disclaimers
                      associated with the use of the AICOPD API
                    </p>
                    <ul className="app-popup-list-container">
                      <li>
                        This is not a diagnostic tool and it does not guarantee
                        the accuracy of the result and cannot be independently
                        acted upon.
                      </li>
                      <li>
                        This Risk score and Clinical Algorithm is a general
                        guideline for Physicians. Any additional laboratory
                        investigations, Diagnostic Imaging, Treatment or Patient
                        Education related to lifestyle management is under the
                        Physician’s or Pulmonologist discretion.
                      </li>
                      <li>
                        To ensure the information in the report is up to date,
                        accurate and correct, Doctor shall be consulted for
                        interpretation of the report. He / She shall also ensure
                        that the entries made in the API are correct.
                      </li>
                      <li>
                        Apollo Hospitals and its Staff does not offer any
                        assurance on the information made available or shall be
                        liable for any loss or damage as the said report is
                        based on the AI based Chronic obstructive pulmonary
                        disease Risk Score without any intervention from their
                        side.
                      </li>
                      <li>
                        By usage of AICOPD Risk Score, it is deemed that the
                        beneficiary of this service has agreed to get the same
                        done at his/her own risk and further agrees with this
                        disclaimer without any limitation or any clauses or
                        sub-clauses.
                      </li>
                    </ul>
                    <p className="app-popup-text">
                      Confidentiality: Each Party hereby undertakes that it will
                      not disclose the Confidential Information of the other
                      party, except to its affiliates, employees, and/or agents
                      who need to know such Confidential Information for the
                      purpose of performance of obligations hereunder, provided
                      they have agreed in writing to keep such information
                      confidential and to not use such information for any
                      unauthorized purposes. The recipient of Confidential
                      Information may disclose Confidential Information as
                      required under Applicable Laws, after giving to the
                      discloser of such Confidential Information, reasonable
                      notice and the opportunity to seek confidential treatment
                      by way of a protective order or similar remedies or relief
                      prior to disclosure, in each case if permitted by
                      applicable Law. Except as set forth in this Agreement,
                      neither Party will issue any public announcement.
                    </p>
                  </div>
                  <div className="app-popup-close-container">
                    <button
                      className="app-popup-close-button"
                      type="button"
                      onClick={triggerTermsBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {props.app === "hypertension" && termsofuse && (
              <div id="aicvd-termsBox" className="app-popup-main-container">
                <div className="app-popup-container">
                  <h1 className="app-popup-content-heading">Terms of Use</h1>
                  <div className="app-popup-content-container">
                    <p className="app-popup-text">
                      By agreeing to use the AI Hypertension Application, I have
                      been made aware of the hardware and software requirements
                      that I will need to set up from my side for a smooth and
                      uninterrupted flow of the Application Programming
                      Interface (API). I undertake to abide by all applicable
                      laws and regulations for the safe and ethical delivery of
                      medical services through this platform and shall adhere by
                      the protocols and standard of care as required. The
                      information that I shared with Apollo Hospitals’ AI
                      Hypertension API, is true to my knowledge and belief and I
                      will be responsible for any legal liability that may arise
                      from in-appropriation of any personal or professional
                      information shared or entered in the API. I accept that I
                      shall be solely responsible for the medical advice and
                      recommendations prescribed post consultation with patients
                      via the AI Hypertension App. and any liability that may
                      arise therefrom. I have understood the following
                      disclaimers associated with the use of the AI Hypertension
                      API
                    </p>
                    <ul className="app-popup-list-container">
                      <li>
                        This is not a diagnostic tool and it does not guarantee
                        the accuracy of the result and cannot be independently
                        acted upon.
                      </li>
                      <li>
                        This Risk score and Clinical Algorithm is a general
                        guideline for Physicians. Any additional laboratory
                        investigations, Diagnostic Imaging, Treatment or Patient
                        Education related to lifestyle management is under the
                        Physician’s or Cardiologist’s discretion.
                      </li>
                      <li>
                        To ensure the information in the report is up to date,
                        accurate and correct, Doctor shall be consulted for
                        interpretation of the report. He / She shall also ensure
                        that the entries made in the API are correct.
                      </li>
                      <li>
                        Apollo Hospitals and its Staff does not offer any
                        assurance on the information made available or shall be
                        liable for any loss or damage as the said report is
                        based on the AI Hypertension Risk Score without any
                        intervention from their side.
                      </li>
                      <li>
                        By usage of AI Hypertension Risk Score, it is deemed
                        that the beneficiary of this service has agreed to get
                        the same done at his/her own risk and further agrees
                        with this disclaimer without any limitation or any
                        clauses or sub-clauses.{" "}
                      </li>
                    </ul>
                    <p className="app-popup-text">
                      Confidentiality: Each Party hereby undertakes that it will
                      not disclose the Confidential Information of the other
                      party, except to its affiliates, employees, and/or agents
                      who need to know such Confidential Information for the
                      purpose of performance of obligations hereunder, provided
                      they have agreed in writing to keep such information
                      confidential and to not use such information for any
                      unauthorized purposes. The recipient of Confidential
                      Information may disclose Confidential Information as
                      required under Applicable Laws, after giving to the
                      discloser of such Confidential Information, reasonable
                      notice and the opportunity to seek confidential treatment
                      by way of a protective order or similar remedies or relief
                      prior to disclosure, in each case if permitted by
                      applicable Law. Except as set forth in this Agreement,
                      neither Party will issue any public announcement.
                    </p>
                  </div>
                  <div className="app-popup-close-container">
                    <button
                      className="app-popup-close-button"
                      type="button"
                      onClick={triggerTermsBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            {privacyPolicy && (
              <div id="aicvd-termsBox" className="app-popup-main-container">
                <div className="app-popup-container">
                  <h1 className="app-popup-content-heading">Privacy Policy</h1>
                  <div className="app-popup-content-container">
                    <p className="app-popup-text">
                      For users, including those under Vendors, Importers, and
                      all entities using the Clinical API.{" "}
                    </p>
                    <p className="app-popup-text">DO NOT -</p>

                    <ul className="app-popup-list-container">
                      <li>
                        Access or use the Clinical AI APIs, Documentation, or
                        associated cloud services except as expressly permitted
                        by the Clinical AI subscription and distribution
                        agreement.
                      </li>
                      <li>
                        Decompile, disassemble, or reverse engineer or attempt
                        to discover any source code or algorithms included in,
                        or accessed by, the Clinical AI APIs or associated cloud
                        services.
                      </li>
                      <li>
                        Hamper with or misuse the technical delivery systems
                        used in connection with the Clinical AI Tool or
                        associated cloud services.{" "}
                      </li>
                      <li>
                        Other than as expressly permitted by Agreement, copy,
                        edit, reproduce, modify, distribute, transmit, sell,
                        resell, display, perform, make translations, or other
                        derivative works of the Clinical AI Tools,
                        Documentation, associated cloud services, or any data or
                        other information made available hereunder or via the
                        Clinical AI APIs & Services
                      </li>
                      <li>
                        Introduce any Viruses into the Clinical AI APIs or
                        Associated cloud services
                      </li>
                      <li>
                        Interfere with, or attempt to interfere with, the
                        Clinical AI APIs or the associated cloud services or the
                        lawful access to or use of the Clinical AI APIs or
                        associated cloud services by any other Person
                      </li>
                      <li>
                        Alter, remove, obscure, or change the location, content,
                        or appearance of any disclaimers, notices of copyright,
                        trademark, service mark, or other proprietary rights, or
                        other notices included in the Clinical AI tools,
                        Documentation, or Associated cloud services
                      </li>
                      <li>
                        Violate any applicable Law in connection with this
                        Agreement or use the Clinical AI APIs and Technology
                        (including any data or other information obtained in
                        connection therewith), or associated cloud services in a
                        way that violates applicable Law or infringes the
                        intellectual property rights of any third party.
                      </li>
                    </ul>
                  </div>
                  <div className="app-popup-close-container">
                    <button
                      className="app-popup-close-button"
                      type="button"
                      onClick={triggerPrivacyBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <footer
          id="footer"
          className="container footer-block"
          style={{ backgroundColor: props.surface_color }}
        >
          <p className="footer-inside-element">
            ©{new Date().getFullYear()} Apollo Hospitals Enterprise Ltd, All
            Rights Reserved
          </p>
          <div className="footer-button-container">
            <button className="landing-footer-button" type="button">
              <a
                className="footer-link-tag"
                href="mailto:clinicalailabs@apollohospitals.com"
              >
                Feedback
              </a>
            </button>
            <button
              className="landing-footer-button"
              type="button"
              onClick={triggerPrivacyBox}
            >
              Privacy Policy
            </button>
          </div>
        </footer>
      </main>
    </div>
  ) : (
    <div className="app-loading-container">
      <div className="login-loader-container">
        <ColorRing
          height="80"
          width="80"
          ariaLabel="bars-loading"
          visible={true}
          colors={["#a09be4", "#a09be4", "#a09be4", "#a09be4", "#a09be4"]}
        />
      </div>
    </div>
  );
};

export default AppLandingPage;
